import React, { useEffect } from "react";
import loadProductReviewsWidget from "services/load-product-reviews-widget";
import loadDetailReviewsWidget from "services/load-detail-reviews-widget";
import { useGlobalContext } from "context/global";

const ProductReviewsSection = ({ data, sku }) => {
	const { langCode } = useGlobalContext();
	const productSku = data.sku || sku;

	useEffect(() => {
		if (data.display_new_widget)
			loadDetailReviewsWidget(productSku, langCode, data);
		else
			loadProductReviewsWidget(productSku, langCode, data);
	}, [langCode]);

	return (
		<div className="mx-auto flex justify-center my-10 md:px-8 xs:px-4 lg:my-20 gap-5 hd-screen-max-width">
			<div className="w-full text-center">
				<div id="ReviewsWidget" />
			</div>
		</div>
	);
};

export default ProductReviewsSection;
